import { Eyebrow, Reveal } from "./Reveal";

const CHAPTERS = [
    ["Occupancy", "Maximizing physical and economic occupancy across every community."],
    ["Collections", "Structured processes that reduce delinquency and strengthen monthly cash flow."],
    ["Operating Expenses", "Vendor management, purchasing controls, and disciplined budgeting."],
    ["Net Operating Income", "The scorecard every operational decision is measured against."],
    ["Property Value", "Operations and renovations that compound into long-term asset value."],
    ["Investor Returns", "Performance that flows through to ownership and investors."],
];

export default function Philosophy() {
    return (
        <section
            id="philosophy"
            data-testid="philosophy-section"
            className="grain relative overflow-hidden bg-[#060C1B] py-24 lg:py-32"
        >
            <div className="pointer-events-none absolute -right-40 top-0 h-[480px] w-[480px] rounded-full bg-[#1BA8E0]/10 blur-3xl" />
            <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
                <Reveal>
                    <Eyebrow>Our Philosophy</Eyebrow>
                    <h2
                        data-testid="philosophy-quote"
                        className="mt-8 max-w-4xl font-serif text-3xl font-light italic leading-[1.25] text-white sm:text-4xl lg:text-5xl"
                    >
                        “We don’t simply manage apartments. We improve{" "}
                        <span className="text-[#1BA8E0]">performance</span>,{" "}
                        <span className="text-[#1BA8E0]">NOI</span>, and{" "}
                        <span className="text-[#1BA8E0]">asset value</span>.”
                    </h2>
                    <p className="mt-8 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">
                        Every operational decision is evaluated based on its impact on six measures.
                    </p>
                </Reveal>
                <div className="mt-16 grid grid-cols-1 gap-x-14 sm:grid-cols-2">
                    {CHAPTERS.map(([title, desc], i) => (
                        <Reveal key={title} delay={(i % 2) * 0.08}>
                            <div
                                data-testid={`philosophy-chapter-${i + 1}`}
                                className="chapter group flex items-start gap-7 border-t border-white/10 py-9"
                            >
                                <span className="chapter-num font-display text-5xl font-extrabold leading-none sm:text-6xl">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <div>
                                    <h3 className="font-serif text-xl italic text-white sm:text-2xl">
                                        {title}
                                    </h3>
                                    <p className="mt-3 max-w-sm text-sm leading-relaxed text-slate-400">
                                        {desc}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
